import {NgModule} from '@angular/core'
import {CommonModule} from '@angular/common'
import {WebsiteDetailedTabsComponent} from './website-detailed-tabs.component'
import {BrowserModule} from '@angular/platform-browser'
import {BrowserAnimationsModule} from '@angular/platform-browser/animations'
import {SharedModule} from '../shared/shared.module'
import {NgbNavModule} from '@ng-bootstrap/ng-bootstrap'
@NgModule({
  imports: [
    BrowserAnimationsModule,
    BrowserModule,
    CommonModule,
    SharedModule,
    NgbNavModule,
  ],
  declarations: [WebsiteDetailedTabsComponent],
  exports: [
    WebsiteDetailedTabsComponent
  ],
  providers: []
})
export class WebsiteDetailedTabsModule {
}
